import React, { FC, useEffect, useRef } from "react";

import { useDataLayer } from "../../../hooks/use-data-layer";
import { GoogleAnalyticsEvent } from "../../../utils/analytics";
import { removeStyleFromHtml } from "../../../utils/styles";
import { Cta } from "../../buttons/cta";
import { EventHeroBanner } from "../event-hero-banner";
import { useEventDetail } from "./event-detail-context";
import { EventDetailSection } from "./event-detail-section";

export const EventDetailInner: FC = () => {
  const videoSectionRef = useRef<HTMLDivElement>(null);
  const { event, labels } = useEventDetail();

  const isPastEvent = event && Date.now() > new Date(event.endDateEvent).getTime();

  const handleScrollToVideo = () => {
    videoSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const { pushEvent } = useDataLayer();
  useEffect(() => {
    pushEvent({
      event: GoogleAnalyticsEvent.ViewEventInfo,
      event_name: event?.title ?? null,
    });
  }, [pushEvent, event]);

  return (
    <>
      <EventHeroBanner onScrollToVideo={handleScrollToVideo} />
      {event?.eventDescription && (
        <EventDetailSection
          title={labels["event-description"] ?? ""}
          description={removeStyleFromHtml(event.eventDescription)}
          isDescriptionHtml
        />
      )}
      {isPastEvent && event?.videoContent && (
        <EventDetailSection
          title={labels["event-past-relive-header"] ?? ""}
          ref={videoSectionRef}
          extra={
            <Cta
              externalUrl={event.url}
              pageLink={null}
              variant="primary"
              label={labels["event-past-relive-cta"] ?? ""}
            />
          }
        />
      )}
    </>
  );
};
